import { createSlice } from "@reduxjs/toolkit";
export const userSlice = createSlice({
  name: "user",
  initialState: {
    user: {},
  },
  reducers: {
    store: (state, user) => {
      state.user = user;
    },
  },
});

export const { store } = userSlice.actions;

export default userSlice.reducer;
